import { render } from "./DeleteReasonReportComponent.vue?vue&type=template&id=49c16b1a"
import script from "./DeleteReasonReportComponent.vue?vue&type=script&lang=js"
export * from "./DeleteReasonReportComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__